import type { AudienceFilters } from './audienceTypes'
import { normalizeDeviceTypeValue } from './deviceTypeFilter'

function sortStringArray<T extends string>(values: readonly T[] | undefined): T[] | undefined {
  if (!values?.length) return undefined
  return [...values].sort((a, b) => a.localeCompare(b))
}

/** Canonical shape for per-panel equality (empty ↔ missing, sorted arrays, device channels). */
export function normalizeAudienceFiltersForCompare(
  filters: AudienceFilters,
): AudienceFilters {
  const next: AudienceFilters = { ...filters }
  if (next.ageRange) {
    const { min, max } = next.ageRange
    if (min == null && max == null) {
      delete next.ageRange
    } else {
      next.ageRange = { min, max }
    }
  }
  if (next.location) {
    const { state, city } = next.location
    if (!state && !city) {
      delete next.location
    } else {
      next.location = { state: state || undefined, city: city || undefined }
    }
  }
  next.gender = sortStringArray(next.gender)
  next.education = sortStringArray(next.education)
  next.employment = sortStringArray(next.employment)
  next.maritalStatus = sortStringArray(next.maritalStatus)
  next.householdSize = sortStringArray(next.householdSize)
  next.numberOfChildren = sortStringArray(next.numberOfChildren)
  next.industry = sortStringArray(next.industry)
  next.housingStatus = sortStringArray(next.housingStatus)
  next.registeredToVote = sortStringArray(next.registeredToVote)
  next.currentVoterRegistration = sortStringArray(next.currentVoterRegistration)
  const deviceType = normalizeDeviceTypeValue(next.deviceType)
  if (deviceType?.length) {
    next.deviceType = [...deviceType].sort((a, b) => a.localeCompare(b))
  } else {
    delete next.deviceType
  }
  if (!next.ekycStatus || next.ekycStatus === 'all') {
    delete next.ekycStatus
  }
  if (!next.senateDistrict?.trim()) {
    delete next.senateDistrict
  }
  return next
}
